// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_y9RzZ","img-wrap":"img-wrap_v-QLv"};